import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { CURRENT_PAGE_QUERY } from '../../graphql.js'
import HomeCards from './HomeCards'

export const CURRENT_PAGE = gql(CURRENT_PAGE_QUERY)

export default function HomeCardsContainer() {
  const { loading, error, data } = useQuery(CURRENT_PAGE, { fetchPolicy: 'cache-first' })

  if (error) return `Error: ${error.message}`
  if (loading || !data) return <Spinner />
  if (data.currentPage) {
    return (
      <div className="home-cards-scroll-container">
        <HomeCards page={data.currentPage} />
      </div>
    )
  }
  return <div>No "Current Home Page" attribute defined.</div>
}
